// extracted by mini-css-extract-plugin
export default {"thymic-episode":"_thymic-episode_93mY3q","trash":"_trash_qPO1IK","patient-age":"_patient-age_qZ7Pwt"};